import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AccessLoggerService } from 'src/app/layouts/admin-layout/access-logger.service';
import { FilterSettings } from '../../model/filter-settings';
import { WidgetWrapper } from '../../model/widget-wrapper';
import { WidgetService } from '../../widget.service';
import { EntityName } from 'src/app/core/models/enumerations/entity-name';
import { SessionAttribute, SessionService } from 'src/app/core/services/session.service';
import { Subscription } from 'rxjs';
import { Widget } from '../../model/widget';

@Component({
    selector: 'app-recently-opened',
    standalone: false,
    templateUrl: './recently-opened.component.html',

})
export class RecentlyOpenedComponent implements OnInit, OnDestroy {
    public rows: any[] = [];
    public filterSettings!: FilterSettings;
    public widgetWrapper!: WidgetWrapper;
    @ViewChild('widgetDataContainer', { static: true })
    widgetDataContainer!: ElementRef;

    private sessionChange?: Subscription;

    constructor(protected widgetService: WidgetService,
        private readonly accessLoggerService: AccessLoggerService,
        private readonly session: SessionService) { }

    ngOnInit(): void {
        this.filterSettings = {
            itemCount: String(this.widgetWrapper.widgetData.itemCount ?? 10),
            entityType: this.widgetWrapper.widgetData.entitiesFilter ? this.widgetWrapper.widgetData.entitiesFilter : [],
            fiterEntities: Widget.getEntitySettings().map(x => ({ ...x}))
        }
        this.filterSettings.fiterEntities.forEach(ent => {
            if (this.filterSettings.entityType.includes(ent.id)) {
                ent.checked = true;
            } else {
                ent.checked = false;
            }
        });
        this.updateData();
        
        this.sessionChange = this.session.attributeChange$.subscribe((csa) => {
            if(csa?.name === SessionAttribute.RecentAccess && csa.newValue)
            {
               this.updateData();
            }
        });
    }
    
    ngOnDestroy(): void {
        this.sessionChange?.unsubscribe();
    }

    public updateData(): void {
        this.rows.length = 0;
        const allItems = this.accessLoggerService.getRecentlyOpened();
        const limit = Number.parseInt(this.filterSettings.itemCount, 10);

        for (const item of allItems) {
            if (this.filterSettings.entityType.length === 0 || this.filterSettings.entityType.includes(item.entityType)) {
                this.rows.push(item);
                if (this.rows.length >= limit) {
                    break;
                }
            }
        }
    }

    public saveSettings(): void {
        this.filterSettings.entityType = this.filterSettings.fiterEntities
            .filter(ent => ent.checked)
            .map(ent => ent.id);
        this.widgetService.saveWidget(this, this.filterSettings, this.widgetWrapper);
        this.widgetWrapper.showProperties = false;
    };

    // This exposes the enum to the template
    public get entityName(): typeof EntityName {
        return EntityName;
    }
}
